import { LocalizeButtonTool } from '@addins/core/singlecallcard';

export class LocalizeDestinationTool extends LocalizeButtonTool {
  constructor() {
    super('LocalizeDest', 'locate', 600);
  }
}
